import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function OfferSection() {
  return <section className="bg-brand-darkGreen py-16 px-4 relative overflow-hidden" data-id="element-125">
      {/* Background pattern/glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-green/20 rounded-full blur-3xl pointer-events-none" data-id="element-126"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-127">
        <motion.div className="bg-brand-yellow text-brand-darkGreen font-bold text-center py-2 px-6 rounded-full inline-block mx-auto mb-8 shadow-lg transform -rotate-2" initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-128">
          ⭐ Más de 500 familias ya lo usan
        </motion.div>

        <motion.div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-brand-orange" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-129">
          <div className="text-center mb-8 relative" data-id="element-130">
            <div className="absolute -top-12 -right-4 md:-right-8 bg-brand-red text-white font-black text-xl md:text-2xl py-4 px-4 rounded-full shadow-xl transform rotate-12 w-24 h-24 flex items-center justify-center border-4 border-white" data-id="element-131">
              53%
              <br data-id="element-132" />
              OFF
            </div>

            <p className="text-gray-500 text-xl md:text-2xl font-bold line-through mb-2" data-id="element-133">
              $35.990
            </p>
            <p className="text-5xl md:text-7xl font-black text-brand-darkGreen mb-4" data-id="element-134">
              $16.990
            </p>
            <p className="text-brand-orange font-bold text-lg" data-id="element-135">
              Pago único • Acceso de por vida
            </p>
          </div>

          <div className="bg-brand-cream rounded-2xl p-6 md:p-8 mb-8" data-id="element-136">
            <h3 className="font-bold text-xl mb-4 text-brand-darkGreen" data-id="element-137">
              Todo lo que te llevás hoy:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-138">
              {['+40 recetas fáciles para viandas', 'Desayunos, meriendas, almuerzos, cenas y snacks', 'Frutas y verduras escondidas', 'Lista de compras lista para usar', 'Checklist semanal de organización', 'Tips para cocinar en menos tiempo', 'Ideas para freezar y reutilizar', 'Ejemplo de menú semanal', 'Acceso inmediato'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-139">
                  <span className="text-brand-green font-bold" data-id="element-140">✔</span>
                  <span className="font-medium text-gray-800" data-id="element-141">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-142">
            <span className="inline-flex items-center gap-2 bg-brand-green/10 text-brand-green font-bold px-4 py-2 rounded-full" data-id="element-143">
              🎁 Acceso inmediato
            </span>
          </div>

          <Button className="w-full max-w-full text-xl md:text-3xl py-5" data-id="element-144">
            QUIERO EL EBOOK AHORA — $16.990
          </Button>

          <div className="text-center mt-4 text-sm text-gray-500 font-medium" data-id="element-145">
            Pago 100% seguro y garantizado
          </div>
        </motion.div>
      </div>
    </section>;
}